import { Component } from '@angular/core';

@Component({
  selector: 'ln-spanish-svg-icon',
  imports: [],
  templateUrl: './spanish-svg-icon.component.html',
  styleUrl: './spanish-svg-icon.component.css',
})
export class SpanishSvgIconComponent {}
